<app-service-detail
    [hideServices]="hideServices">
    <app-sidenav *ngIf="hideServices"></app-sidenav>
    <app-variables-tabs *ngIf="!hideServices" primarySelectedTab="InstanceCatalogs" class="container-fluid px-5">
    </app-variables-tabs>
    <div *ngIf="hideServices"
        class="col-12 px-0 sticky-overlap-fixer">
        <div class="row">
            <div class="col-8 pl-md-5 list-header">
                <h1 class="list-header-title" style="margin: 0 15px;">
                    {{'Instance Catalogs' | translate}}
                </h1>
            </div>
        </div>
    </div>

    <div class="col-12 px-0">
        <div class="row">
            <div class="col-12 pl-md-5 ml-auto list-header">
                <tabset type="tabs"
                        class="pill underline-pill-tabs"
                        style="background: white">
                    <tab class="mt-2"
                        (select)="onSelect($event)">
                        <ng-template tabHeading>
                            {{ 'classification.classification' | translate }} ({{numberClassifications | number}})
                        </ng-template>
                        <other-classification [hideList]="hideList" [determinantMapById]="determinantMapById"
                                              (sendClassificationNumber)="setClassificationsCounter($event)">
                        </other-classification>
                    </tab>
                    <tab class="mt-2">
                        <ng-template tabHeading>
                            {{ 'classification.document_rejection' | translate }} ({{numberRejectionReasons | number}})
                        </ng-template>
                        <other-classification [hideList]="hideList" [isRejectionCatalogs]="true" (sendClassificationNumber)="setRejectionReasonsCounter($event)"></other-classification>
                    </tab>
                    <tab class="mt-2">
                        <ng-template tabHeading>
                            {{ 'classification.activity_condition_type' | translate }} ({{numberConditionTypes | number}})
                        </ng-template>
                        <activity-condition-type (sendCounter)="setConditionTypesCounter($event)"></activity-condition-type>
                    </tab>
                    <!-- not used for now #TOBE-4749 -->
                    <tab *ngIf="false" style="background: white"
                        class="mt-2"
                        heading="{{ 'header.classification_registration' | translate }}">
                        <classification-registration></classification-registration>
                    </tab>
                </tabset>
            </div>
        </div>
    </div>
</app-service-detail>
